import axios from "axios";
import API from "../../../services/API";
import { trackPromise } from "react-promise-tracker";
import Formatter from "../../../services/Formatter";
import moment from 'moment';
import $ from 'jquery';
import { getRecentDtr } from "../dashboard/dashboardActions";

// Action for Biometrixlog
export const biometrixLog = ( post_data, id ) => {
    return (dispatch, getState) => {
        API.call({
            method: "post",
            url: "/dtr/quickpunch/",
            data: post_data
        })
        .then(result => {
            dispatch({
                'type'      : 'FETCH_RECENT_DTR', 
                'recent_dtr'      : result.data.content.dtr_records,
            });
            dispatch( Formatter.alert_success( result ));
            $(".nav-clock.dropdown-toggle.btn.btn-primary").click();
        })
        .catch(e => {
            dispatch( Formatter.alert_error( e ) ) 
        });
    }
}

// Action for Biometrixlog for Multi
export const biometrixLogMulti = (post_data, id) => {
    return (dispatch) => {

        return API.call({
            method: "post",
            url: "/dtr/quickpunch_multi/",
            data: post_data
        })
        .then(result => {

            var from = moment().subtract(1, 'days').format("YYYY-MM-DD");
            var to = moment().format("YYYY-MM-DD");

            return API.call({
                method: "get",
                url: "/dtr/punch/" + id + "/" + from + "/" + to,
            });
        })
        .then(result => {

            dispatch({
                type: "FETCH_RECENT_PUNCH",
                data: result.data
            });

            return result;
        })
        .catch(e => {
            dispatch(Formatter.alert_error(e));
            throw e;
        });
    }
}

// Action for fetching Projects and Tasks Data
export const fetchProjectTaskData = (id = null) => {
  return (dispatch, getState) => {
    return API.call({
      method: "get",
      url: "/dtr/quickpunch/projecttasks",
      params: {
        alter_punch_id: id
      }
    })
    .then(result => {
      return result.data.content;
    })
    .catch(e => {
      dispatch(Formatter.alert_error(e));
      return {
        projects: null,
        tasks_data: null
      };
    });
  }
}
